import {Capability} from "./api";

export const milliPerOne = 1000;
export const formPagesWidth = 800;
export const formPagesWidthDialog = 600;
export const formCheckboxMargin = -12;
export const UNLIMITED = 2147483647;
export const BASE_CAPABILITY_SET_NAME = "base";
export const AUTO_PREFIX = "#auto";

/**
 * These capabilities need more checks when updating an extension
 */
export const CapabilitiesThatCanBeUsed = [
    Capability.CcAgent, // Agent is used if extension in any call queue
    Capability.CcSupervisor, // Supervisor is used when an extension is set as supervisor in a call queue
] as const;
